/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './resolveDid.defs'
export { main as default } from './resolveDid.defs'
